// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"94":"57e5b827","618":"846dd1fe","813":"cdf7d305"}[chunkId] + ".css";
};